import React from 'react';

export const EnvironmentContext = React.createContext({
  environment: 'vistaprint-production',
  // eslint-disable-next-line no-unused-vars
  setEnvironment: env => {},
});
